export const types = {
    login : '[auth] Login',
    logout: '[auth] Logout',
    updateUser: '[auth] updateUser',
    loader: '[auth] loader',
    authTrue: '[auth] auth',
    updatePermis: '[auth] updatePermis',
    contratomarcoId: '[auth] marco',
    showMenu: '[auth] showMenu'
}
